module.exports = __webpack_public_path__ + "b3fe99ab4fbf1c4fb2b853283096af82.png";